module.exports = require('./helpers/bundle-url').getBundleURL('9rAa3') + "save-recovery-key.57011d69.svg";